import { getPlatform } from './getPlatform'

/**
 * 百度统计
 * @param id
 */
export default function baiduStat(id = 'd64469e9d7bdbf03af6f074dffe7f9b5') {
  const platform = getPlatform()
  const isApp =
    platform.isYixinliApp || platform.isCeShiApp || platform.isZiXunApp
  // app内不做统计
  if (isApp) {
    return
  }
  var _hmt = _hmt || []
  ;(function() {
    // 百度统计代码
    var hm = document.createElement('script')
    hm.src = `https://hm.baidu.com/hm.js?${id}`
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })()

  // 百度推送的代码
  var bp = document.createElement('script')
  var curProtocol = window.location.protocol.split(':')[0]
  if (curProtocol === 'https') {
    bp.src = 'https://zz.bdstatic.com/linksubmit/push.js'
  } else {
    bp.src = 'http://push.zhanzhang.baidu.com/push.js'
  }
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(bp, s)
}
